module.exports = __webpack_public_path__ + "img/13.fc5ddf9f.jpg";